import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchSmartmeter } from './smartmeterAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk to fetch data with filters
export const fetchSmartmeterDataWithFilters = createAsyncThunk(
  'smartmeter/fetchSmartmeterDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchSmartmeter({ filter, options }); // Pass filters to the API
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const smartmeterSlice = createSlice({
  name: 'smartmeter',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchSmartmeterDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchSmartmeterDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchSmartmeterDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

export const selectSmartmeterData = (state) => state.smartmeter.data;
export const selectSmartmeterStatus = (state) => state.smartmeter.status;
export const selectSmartmeterError = (state) => state.smartmeter.error;

export default smartmeterSlice.reducer;
